import { Component, OnInit } from '@angular/core';
import * as titleActions from './../shared/state/actions/title.action';
import * as fromShared from "./../shared/state/reducers";
import { Store } from '@ngrx/store';

@Component({
  selector: 'ats-user-home',
  templateUrl: './user.home.component.html',
})

export class UserHomeComponent implements OnInit {

  constructor(private sharedStore: Store<fromShared.State>) { }

  pageTitle = "Home";

  ngOnInit() {
    this.sharedStore.dispatch(titleActions.SetTitle({ title: this.pageTitle }));

  }
}
